
import styled from "styled-components";

export const ToggleSwitchContainer = styled.label`
  /* switch */
  --switch-bg: rgb(135, 150, 165);
  --switch-width: 48px;
  --switch-height: 16px;
  /* circle */
  --circle-diameter: 24px;
  --circle-bg: rgb(0, 56, 146);
  --circle-inset: calc((var(--circle-diameter) - var(--switch-height)) / 2);
  margin-bottom: 4px;
`;

export const HiddenInput = styled.input.attrs({ type: 'checkbox' })`
  display: none;
`;

export const Slider = styled.span`
  width: var(--switch-width);
  height: var(--switch-height);
  background: var(--switch-bg);
  border-radius: 999px;
  position: relative;
  cursor: pointer;
  display: block;
`;

interface CircleProps {
  checked?: boolean;
  bgImage?: string;
  bgImageChecked?: string;
}

export const Circle = styled.span<CircleProps>`
  top: calc(var(--circle-inset) * -1);
  left: 0;
  width: var(--circle-diameter);
  height: var(--circle-diameter);
  position: absolute;
  background: var(--circle-bg);
  border-radius: inherit;
  background-image: ${({ checked, bgImage, bgImageChecked }) =>
    checked ? bgImageChecked : bgImage};
  background-repeat: no-repeat;
  background-position: center center;
  transition: left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
`;

interface CircleBeforeProps {
  active?: boolean;
}

export const CircleBefore = styled.span<CircleBeforeProps>`
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.75);
  border-radius: inherit;
  transition: all 500ms;
  opacity: ${({ active }) => (active ? 1 : 0)};
  width: ${({ active }) => (active ? 0 : '100%')};
  height: ${({ active }) => (active ? 0 : '100%')};
`;


interface ToggleSwitchNewProps {
  id: string;
  value: boolean;
  title: string;
  backgroundImage: string;
  backgroundImageChecked: string;
  onChange: (value: boolean) => void;
}

const ToggleSwitchNew = ({
  id,
  value,
  title,
  backgroundImage,
  backgroundImageChecked,
  onChange,
}: ToggleSwitchNewProps) => {
  return (
    <ToggleSwitchContainer title={title}>
      <HiddenInput
        id={id}
        checked={value}
        onChange={(e) => onChange(e.target.checked)}
      />
      <Slider>
        <Circle
          checked={value}
          bgImage={`url(${backgroundImage})`}
          bgImageChecked={`url(${backgroundImageChecked})`}
          style={{
            left: value
              ? "calc(var(--switch-width) - var(--circle-diameter))"
              : "0",
            transition: "left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
          }}
        >
          <CircleBefore active={false} />
        </Circle>
      </Slider>
    </ToggleSwitchContainer>
  );
};

export default ToggleSwitchNew;
